import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'channelId',
      type: 'select',
      label: '直播间',
      clearable: true,
      placeholder: '请选择直播间'
    },
    {
      field: 'timeSlot',
      type: 'datepicker',
      label: '筛选日期',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    }
  ]
}
